import { render, staticRenderFns } from "./MarketplacesCategory.vue?vue&type=template&id=07d3748a&scoped=true&"
import script from "./MarketplacesCategory.vue?vue&type=script&lang=js&"
export * from "./MarketplacesCategory.vue?vue&type=script&lang=js&"
import style0 from "./MarketplacesCategory.vue?vue&type=style&index=0&id=07d3748a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3748a",
  null
  
)

export default component.exports